package one.primehealth.app

import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.SupervisorJob
import kotlinx.coroutines.channels.Channel
import kotlinx.coroutines.launch

class DeepLinkChannel {

    val channel = Channel<DeepLink>()

    private val scope = CoroutineScope(Dispatchers.Main.immediate + SupervisorJob())

    fun add(deepLink: DeepLink) {
        scope.launch {
            channel.send(deepLink)
        }
    }
}